import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../Utils/api";
import { useSelector } from "react-redux";

export default function AddTaskModal({ isOpen, onClose, getTaskList, task }) {
  const [users, setUsers] = useState([]);

  const user = useSelector((state) => state.user).user;

  const [formData, setFormData] = useState({
    title: "",
    dueDate: new Date().toISOString(),
    notes: "",
    userID: user?._id,
    assignTo: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const getUsers = async () => {
    try {
      const response = await api.get("/user");
      setUsers(response.data.users.filter((u) => !u.archive));
    } catch (error) {
      console.error(error);
    }
  };

  const submitTask = async (event) => {
    event.preventDefault();

    // Validate inputs
    if (
      formData.title.trim() === "" ||
      formData.dueDate === "" ||
      formData.notes.trim() === ""
    ) {
      toast.info("Please fill in all required fields.");
      return;
    }
    if (formData.userID === "") {
      toast.info("User ID");
      return;
    }
    const res = await api.post("/task", formData);
    if (res.data.success) {
      toast.success("Task added successfully");
      getTaskList();
      onClose();
    } else {
      toast.error("Failed to add task");
    }
    clearFields();
    onClose();
  };

  const clearFields = () => {
    setFormData({
      title: "",
      dueDate: new Date().toISOString(),
      notes: "",
      userID: "",
    });
  };

  useEffect(() => {
    getUsers();
  }, []);

  useEffect(() => {
    if (task) {
      setFormData({
        ...task,
        assignTo: task.assignTo.id,
      });
    }
  }, [task]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[999]">
      <div className="bg-white rounded-lg w-full max-w-lg p-6 shadow-lg">
        {/* Header */}
        <div className="flex items-center mb-6">
          <h2 className="text-2xl text-left font-semibold  w-full text-gray-800">
            Add Task
          </h2>
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-2xl text-gray-500 hover:text-gray-800"
          >
            &times;
          </button>
        </div>

        {/* Task Title */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1 text-left">
            Task Title
          </label>
          <input
            type="text"
            placeholder="e.g. Pack up the café after closing."
            value={formData.title}
            name="title"
            onChange={handleInputChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-500"
          />
        </div>

        {/* Assignee */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1 text-left">
            Assign to
          </label>
          <select
            value={formData.assignTo}
            name="assignTo"
            onChange={handleInputChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-500"
          >
            <option></option>
            {users.map((user) => (
              <option key={user._id} value={user._id}>
                {user.preferredName}
              </option>
            ))}
          </select>
        </div>

        {/* Due Date */}
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1 text-left">
            Due Date
          </label>
          <input
            type="date"
            name="dueDate"
            value={formData.dueDate.split("T")[0]}
            onChange={handleInputChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-500"
          />
        </div>

        {/* Notes */}
        <div className="mb-6">
          <label className="block text-sm font-medium mb-1 text-left">
            Notes
          </label>
          <textarea
            placeholder="(Optional)"
            value={formData.notes}
            name="notes"
            onChange={handleInputChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 h-24 resize-none focus:outline-none focus:ring-2 focus:ring-gray-500"
          ></textarea>
        </div>

        {/* Footer buttons */}
        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="bg-gray-100 text-gray-800 px-4 py-2 rounded-md hover:bg-gray-200"
          >
            Close
          </button>
          <button
            onClick={submitTask}
            className="bg-gray-600 text-white px-4 py-2 rounded-md hover:bg-gray-700"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
